//
// matches EnumIncludeType.java
//
export const ALL = 'all';
export const LATEST = 'latest';
export const EARLIEST = 'earliest';
export const COUNT = 'count';

export type IncludeType =
  | typeof ALL
  | typeof LATEST
  | typeof EARLIEST
  | typeof COUNT;
